import { useCallback } from 'react'
import { getLaborValues, roundTo2 } from '../utils/functions'
import { GET_MAX_LABOR_VALUE } from '../utils/constants'

export function useLaborValueUpdate({ getValues, setValue, budgetType }) {
  const updateLaborValues = useCallback(
    (comps, laborValues) => {
      comps.forEach((compartment, cIndex) => {
        const resolutions = compartment?.inspectionBudgetResolutions || []

        resolutions.forEach((resolution, rIndex) => {
          const laborType = resolution?.service?.laborType
          const id = laborType?.id

          let laborValue = 0
          let laborValueMax = 0

          if (id) {
            const group = laborValues.laborGroups[id]

            if (group?.totalMO && group?.totalMoValue) {
              const coef = (resolution?.laborTime || 0) / group.totalMO
              laborValue = coef * group.totalMoValue

              if (laborValues.hasValidPainting && laborType?.slug !== 'painting') {
                laborValue *= laborType?.paintingAppliedPercentage ?? 1
              }
            }
            if (GET_MAX_LABOR_VALUE[budgetType] && group?.totalMO && group?.totalMoValueMax) {
              const coef = (resolution?.laborTime || 0) / group.totalMO
              laborValueMax = coef * group.totalMoValueMax

              if (laborValues.hasValidPainting && laborType?.slug !== 'painting') {
                laborValueMax *= laborType?.paintingAppliedPercentage ?? 1
              }
            }
          }

          const nextLaborValue = roundTo2(laborValue)
          const nextLaborValueMax = roundTo2(laborValueMax)

          if (resolution?.laborValue !== nextLaborValue) {
            setValue(
              `inspectionBudgetCompartments.${cIndex}.inspectionBudgetResolutions.${rIndex}.laborValue`,
              nextLaborValue,
              { shouldDirty: false }
            )
          }

          if (GET_MAX_LABOR_VALUE[budgetType] && resolution?.laborValueMax !== nextLaborValueMax) {
            setValue(
              `inspectionBudgetCompartments.${cIndex}.inspectionBudgetResolutions.${rIndex}.laborValueMax`,
              nextLaborValueMax,
              { shouldDirty: false }
            )
          }
        })
      })
    },
    [setValue]
  )

  const getAndUpdateLaborValue = useCallback(
    ({ compartmentIndex, resolutionIndex, laborTime } = {}) => {
      const { inspectionBudgetCompartments = [] } = getValues()

      const normalizedCompartments = inspectionBudgetCompartments.map(compartment => ({
        ...compartment,
        inspectionBudgetResolutions: (compartment?.inspectionBudgetResolutions || []).filter(
          Boolean
        ),
      }))

      const updatedCompartments = normalizedCompartments.map((compartment, cIndex) => ({
        ...compartment,
        inspectionBudgetResolutions: compartment.inspectionBudgetResolutions.map(
          (resolution, rIndex) => {
            if (
              cIndex !== compartmentIndex ||
              rIndex !== resolutionIndex ||
              laborTime === undefined
            ) {
              return resolution
            }
            return { ...resolution, laborTime }
          }
        ),
      }))

      const resolutions = updatedCompartments.flatMap(c => c?.inspectionBudgetResolutions || [])
      const laborValues = getLaborValues(resolutions)
      if (!laborValues?.laborGroups) return

      updateLaborValues(updatedCompartments, laborValues)
    },
    [getValues, updateLaborValues]
  )

  return { updateLaborValues, getAndUpdateLaborValue }
}
